<template>
	<div>
		<a-modal v-show='!ishand' id='getpass' width='28rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">
					更改用户密碼
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="border-radius: 0 0 10px 10px;">
				<div style="padding-top: 1.5rem;">
					<div style="width:85%;margin: 0 auto;">
						<div class='warp_four'>
							<div class='leftwarp'>現時密碼</div>
							<div class='rightwarp'>
								<a-input-password v-model="form.oldpassword" class='warp_width' placeholder='' :maxLength='18'/>
							</div>
						</div>
						<div class='warp_four'>
							<div class='leftwarp'>新密碼</div>
							<div class='rightwarp'>
								<a-input-password v-model="form.newpass" class='warp_width' placeholder=''
								:maxLength='8'/>
								<!-- @blur='passfn(form.newpass)' -->
							</div>
						</div>
						<div class='warp_four'>
							<div class='leftwarp'>確認新密碼</div>
							<div class='rightwarp'>
								<a-input-password v-model="form.newpassword" class='warp_width ' placeholder=''
								:maxLength='8'/>
								<!-- @blur='passfn(form.newpassword)'  -->
							</div>
						</div>
					</div>
					<div style="width:85%;line-height: 1.5rem;margin-top: .2rem;margin: 0 auto;color: #666;">
						密碼有效字數為8位，密碼須包含數字、英文（大寫）、英文（小寫），
						但不能包含三個或以上連續相同的字符。為描保密碼的安全，新密碼不接受與舊密碼或登入名稱相同.
					</div>
					<div style="margin: 1rem 0;border-bottom:1px solid #d8d8d8;width: 100%;height: 1px;"></div>
					</a-form-model>
					<div style="text-align: center;padding-bottom: 1rem;">
						<button class='btn1 btnx' @click='passmi'>確定</button>
						<button class='btn1 btn2' @click='handleCancel'>取消</button>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: ['openstatic'],
		data() {
			return {
				england: 'cn',
				visible: true,
				ishand: false,
				rules: {},
				form: {
					"newpassword": "",
					"oldpassword": "",
					newpass: '',
				},
			}
		},
		methods: {
			passmi() {
				if(this.passfn(this.form.newpassword)){//||this.passfn(this.form.oldpassword)
					return
				}
				if (this.form.newpassword == this.form.oldpassword) {
					this.$message.warning('新密碼舊密碼不能重復')
					return
				}
				if (this.form.newpassword == this.form.newpass) {
					this.form.token = this.$store.state.token
					this.$ajax({
						url: this.$api.editUserPassword,
						method: 'post',
						data: this.form
					}).then(res => {
						if (res.data.qmiscode === 1000) {
							this.$message.success('密碼修改成功，請重新登錄')
							setTimeout(()=>{
								this.$router.push({
									path: '/'
								})
							},200)
						}else{
							this.$message.warning(res.data.qmismsg)
						}
					})
				} else {
					this.$message.warning('兩次輸入的新密碼不一致');
				}
			},
			passfn(val) {
				var reg = /^(?![^a-z]+$)(?![^A-Z]+$)(?!\D+$).{8,8}$/;
				var re = /(\w)*(\w)\2{2}(\w)*/g;
				if (!reg.test(val)) {
					this.$message.warning('輸入的新密碼至少包含一個大寫字母，小寫字母和數字，長度在8')
					return true
				}
				if (re.test(val)) {
					this.$message.warning('不能包含三個或以上連續相同的字符')
					return true
				}
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#getpass {
		.ant-modal-header,
		.ant-modal-body {
			background-color: #fff !important;
		}
		.warp_width> .ant-input{
			border: 0;
			outline: none !important; // 去除选中状态边框
			width: 100%;
			border-bottom: 1px solid #d8d8d8;
			border-radius: 0;
		}

		.warp_width > .ant-input:focus {
			border-color: #fff;
			webkit-box-shadow: none;
			box-shadow: none;
			border-bottom: 2px solid rgb(12, 139, 151);
		}

		.ant-modal {
			top: 20vh;
		}

		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem
			}
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: 1rem !important;
		}

		.a-input-password {
			font-size: 8rem !important;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}



		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
<style lang='scss' scoped>
	.warp_four {
		overflow: hidden;
		margin-bottom: 1rem;
		position: relative;

		.leftwarp {
			/* position: absolute; */
			left: .5rem;
			color: #000;
			z-index: 100;
			font-size: .8rem;
			line-height: 2rem;
		}

		.rightwarp {
			width: 100%;
		}
	}

	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}


	/* #getpass .warp_widths{
			padding-left: 6rem;
		} */

	.btn1 {
		width: 5rem;
		height: 2rem;
		font-size: .8rem;
		color: #fff;
		border: 0;
		border-radius: 5px;
		margin: 0 2.5rem;
	}

	.btnx {
		background-color: #0c8b97;
	}

	.btn2 {
		background-color: #c2c2c2;
	}
</style>
